import { capitalizeFirstLetterFormatter, formatWithMap } from "util/formaters";
import type { PaymentMethod } from "./types";
import { paymentMethods } from "consts/paymentMethods";

export const formatPaymentMethodName = (tag: PaymentMethod['tag']) => (
    formatWithMap(tag, paymentMethods) ||
    capitalizeFirstLetterFormatter(tag)
);
